<template>
  <div class="intro-y">
    <NoteList :list="noteList" :is-loading="isLoading" :title="$t('text.loanNotes')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NOTE_LIST_REQUEST } from '@/store/actions/note';
import dataListMixin from '@/mixins/dataListMixin';
import NoteList from '@/components/note/NoteList';

export default {
  mixins: [dataListMixin],

  props: {
    customer: Object,
  },

  components: {
    NoteList,
  },

  data() {
    return {
      storeActionListRequest: NOTE_LIST_REQUEST,
      perPage: 100,
    };
  },

  computed: {
    ...mapGetters(['noteList', 'noteListStatus']),
    isLoading() {
      return this.noteListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[userId]`] = this.customer.id;
    },
  },
};
</script>
